/**
 * Snippets API
 * Here is the API DNA
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { FolderDocumentCategory } from './folderDocumentCategory';

export interface FolderDocumentsMetadata {
  requiredDocuments: Array<FolderDocumentsMetadata.RequiredDocumentsEnum>;
  missingDocuments: Array<FolderDocumentsMetadata.MissingDocumentsEnum>;
  pendingAutoUploadedDocuments: Array<FolderDocumentsMetadata.PendingAutoUploadedDocumentsEnum>;
  documentTypes: Array<FolderDocumentsMetadata.DocumentTypesEnum>;
  docTypeCategories: { [key: string]: string };
  docTypeCategoriesMeta: Array<FolderDocumentCategory>;
  docTypeAutoUploaded: { [key: string]: boolean };
}
export namespace FolderDocumentsMetadata {
  export type RequiredDocumentsEnum =
    | 'COMP'
    | 'ACTE'
    | 'TITRE'
    | 'EHYP'
    | 'CAD'
    | 'CAD-REDUIT'
    | 'RU'
    | 'PEB'
    | 'PEB_COMMUN'
    | 'DECOM'
    | 'CI'
    | 'REG'
    | 'ELEC'
    | 'BDES'
    | 'MAIN'
    | 'GARAN'
    | 'VENTE'
    | 'DEPOT'
    | 'BAIL'
    | 'CERTI'
    | 'OVAM'
    | 'CRED'
    | 'ACTE_CRED'
    | 'ACTE_MAND'
    | 'EH_COMPL'
    | 'EH_DEMANDE'
    | 'OTHER'
    | 'IBGE'
    | 'ARTICLE90'
    | 'COMP_SIGNE'
    | 'ACTE_MAIN'
    | 'OFFRE'
    | 'MAP'
    | 'WATERTOETS'
    | 'ASBEST'
    | 'REGISTER'
    | 'ERFGOED'
    | 'CRF'
    | 'RVV'
    | 'BCE'
    | 'PLAN_CAD'
    | 'DOC_SYNDIC'
    | 'ACTE_BASE'
    | 'ANNEX_BASE'
    | 'ETAT_LIEUX'
    | 'GARANTIE_LOC'
    | 'ACTE_HEREDITE'
    | 'DEMANDE_RU'
    | 'DECLA_SUCC'
    | 'PERMIS_URB'
    | 'PERMIS_ENV'
    | 'REG_BENEF'
    | 'MAATREGELEN'
    | 'AR_REC'
    | 'LETTRE_VENTE'
    | 'ANB'
    | 'SCHEMA_UNIF';
  export const RequiredDocumentsEnum = {
    COMP: 'COMP' as RequiredDocumentsEnum,
    ACTE: 'ACTE' as RequiredDocumentsEnum,
    TITRE: 'TITRE' as RequiredDocumentsEnum,
    EHYP: 'EHYP' as RequiredDocumentsEnum,
    CAD: 'CAD' as RequiredDocumentsEnum,
    CADREDUIT: 'CAD-REDUIT' as RequiredDocumentsEnum,
    RU: 'RU' as RequiredDocumentsEnum,
    PEB: 'PEB' as RequiredDocumentsEnum,
    PEBCOMMUN: 'PEB_COMMUN' as RequiredDocumentsEnum,
    DECOM: 'DECOM' as RequiredDocumentsEnum,
    CI: 'CI' as RequiredDocumentsEnum,
    REG: 'REG' as RequiredDocumentsEnum,
    ELEC: 'ELEC' as RequiredDocumentsEnum,
    BDES: 'BDES' as RequiredDocumentsEnum,
    MAIN: 'MAIN' as RequiredDocumentsEnum,
    GARAN: 'GARAN' as RequiredDocumentsEnum,
    VENTE: 'VENTE' as RequiredDocumentsEnum,
    DEPOT: 'DEPOT' as RequiredDocumentsEnum,
    BAIL: 'BAIL' as RequiredDocumentsEnum,
    CERTI: 'CERTI' as RequiredDocumentsEnum,
    OVAM: 'OVAM' as RequiredDocumentsEnum,
    CRED: 'CRED' as RequiredDocumentsEnum,
    ACTECRED: 'ACTE_CRED' as RequiredDocumentsEnum,
    ACTEMAND: 'ACTE_MAND' as RequiredDocumentsEnum,
    EHCOMPL: 'EH_COMPL' as RequiredDocumentsEnum,
    EHDEMANDE: 'EH_DEMANDE' as RequiredDocumentsEnum,
    OTHER: 'OTHER' as RequiredDocumentsEnum,
    IBGE: 'IBGE' as RequiredDocumentsEnum,
    ARTICLE90: 'ARTICLE90' as RequiredDocumentsEnum,
    COMPSIGNE: 'COMP_SIGNE' as RequiredDocumentsEnum,
    ACTEMAIN: 'ACTE_MAIN' as RequiredDocumentsEnum,
    OFFRE: 'OFFRE' as RequiredDocumentsEnum,
    MAP: 'MAP' as RequiredDocumentsEnum,
    WATERTOETS: 'WATERTOETS' as RequiredDocumentsEnum,
    ASBEST: 'ASBEST' as RequiredDocumentsEnum,
    REGISTER: 'REGISTER' as RequiredDocumentsEnum,
    ERFGOED: 'ERFGOED' as RequiredDocumentsEnum,
    CRF: 'CRF' as RequiredDocumentsEnum,
    RVV: 'RVV' as RequiredDocumentsEnum,
    BCE: 'BCE' as RequiredDocumentsEnum,
    PLANCAD: 'PLAN_CAD' as RequiredDocumentsEnum,
    DOCSYNDIC: 'DOC_SYNDIC' as RequiredDocumentsEnum,
    ACTEBASE: 'ACTE_BASE' as RequiredDocumentsEnum,
    ANNEXBASE: 'ANNEX_BASE' as RequiredDocumentsEnum,
    ETATLIEUX: 'ETAT_LIEUX' as RequiredDocumentsEnum,
    GARANTIELOC: 'GARANTIE_LOC' as RequiredDocumentsEnum,
    ACTEHEREDITE: 'ACTE_HEREDITE' as RequiredDocumentsEnum,
    DEMANDERU: 'DEMANDE_RU' as RequiredDocumentsEnum,
    DECLASUCC: 'DECLA_SUCC' as RequiredDocumentsEnum,
    PERMISURB: 'PERMIS_URB' as RequiredDocumentsEnum,
    PERMISENV: 'PERMIS_ENV' as RequiredDocumentsEnum,
    REGBENEF: 'REG_BENEF' as RequiredDocumentsEnum,
    MAATREGELEN: 'MAATREGELEN' as RequiredDocumentsEnum,
    ARREC: 'AR_REC' as RequiredDocumentsEnum,
    LETTREVENTE: 'LETTRE_VENTE' as RequiredDocumentsEnum,
    ANB: 'ANB' as RequiredDocumentsEnum,
    SCHEMAUNIF: 'SCHEMA_UNIF' as RequiredDocumentsEnum,
  };
  export type MissingDocumentsEnum =
    | 'COMP'
    | 'ACTE'
    | 'TITRE'
    | 'EHYP'
    | 'CAD'
    | 'CAD-REDUIT'
    | 'RU'
    | 'PEB'
    | 'PEB_COMMUN'
    | 'DECOM'
    | 'CI'
    | 'REG'
    | 'ELEC'
    | 'BDES'
    | 'MAIN'
    | 'GARAN'
    | 'VENTE'
    | 'DEPOT'
    | 'BAIL'
    | 'CERTI'
    | 'OVAM'
    | 'CRED'
    | 'ACTE_CRED'
    | 'ACTE_MAND'
    | 'EH_COMPL'
    | 'EH_DEMANDE'
    | 'OTHER'
    | 'IBGE'
    | 'ARTICLE90'
    | 'COMP_SIGNE'
    | 'ACTE_MAIN'
    | 'OFFRE'
    | 'MAP'
    | 'WATERTOETS'
    | 'ASBEST'
    | 'REGISTER'
    | 'ERFGOED'
    | 'CRF'
    | 'RVV'
    | 'BCE'
    | 'PLAN_CAD'
    | 'DOC_SYNDIC'
    | 'ACTE_BASE'
    | 'ANNEX_BASE'
    | 'ETAT_LIEUX'
    | 'GARANTIE_LOC'
    | 'ACTE_HEREDITE'
    | 'DEMANDE_RU'
    | 'DECLA_SUCC'
    | 'PERMIS_URB'
    | 'PERMIS_ENV'
    | 'REG_BENEF'
    | 'MAATREGELEN'
    | 'AR_REC'
    | 'LETTRE_VENTE'
    | 'ANB'
    | 'SCHEMA_UNIF';
  export const MissingDocumentsEnum = {
    COMP: 'COMP' as MissingDocumentsEnum,
    ACTE: 'ACTE' as MissingDocumentsEnum,
    TITRE: 'TITRE' as MissingDocumentsEnum,
    EHYP: 'EHYP' as MissingDocumentsEnum,
    CAD: 'CAD' as MissingDocumentsEnum,
    CADREDUIT: 'CAD-REDUIT' as MissingDocumentsEnum,
    RU: 'RU' as MissingDocumentsEnum,
    PEB: 'PEB' as MissingDocumentsEnum,
    PEBCOMMUN: 'PEB_COMMUN' as MissingDocumentsEnum,
    DECOM: 'DECOM' as MissingDocumentsEnum,
    CI: 'CI' as MissingDocumentsEnum,
    REG: 'REG' as MissingDocumentsEnum,
    ELEC: 'ELEC' as MissingDocumentsEnum,
    BDES: 'BDES' as MissingDocumentsEnum,
    MAIN: 'MAIN' as MissingDocumentsEnum,
    GARAN: 'GARAN' as MissingDocumentsEnum,
    VENTE: 'VENTE' as MissingDocumentsEnum,
    DEPOT: 'DEPOT' as MissingDocumentsEnum,
    BAIL: 'BAIL' as MissingDocumentsEnum,
    CERTI: 'CERTI' as MissingDocumentsEnum,
    OVAM: 'OVAM' as MissingDocumentsEnum,
    CRED: 'CRED' as MissingDocumentsEnum,
    ACTECRED: 'ACTE_CRED' as MissingDocumentsEnum,
    ACTEMAND: 'ACTE_MAND' as MissingDocumentsEnum,
    EHCOMPL: 'EH_COMPL' as MissingDocumentsEnum,
    EHDEMANDE: 'EH_DEMANDE' as MissingDocumentsEnum,
    OTHER: 'OTHER' as MissingDocumentsEnum,
    IBGE: 'IBGE' as MissingDocumentsEnum,
    ARTICLE90: 'ARTICLE90' as MissingDocumentsEnum,
    COMPSIGNE: 'COMP_SIGNE' as MissingDocumentsEnum,
    ACTEMAIN: 'ACTE_MAIN' as MissingDocumentsEnum,
    OFFRE: 'OFFRE' as MissingDocumentsEnum,
    MAP: 'MAP' as MissingDocumentsEnum,
    WATERTOETS: 'WATERTOETS' as MissingDocumentsEnum,
    ASBEST: 'ASBEST' as MissingDocumentsEnum,
    REGISTER: 'REGISTER' as MissingDocumentsEnum,
    ERFGOED: 'ERFGOED' as MissingDocumentsEnum,
    CRF: 'CRF' as MissingDocumentsEnum,
    RVV: 'RVV' as MissingDocumentsEnum,
    BCE: 'BCE' as MissingDocumentsEnum,
    PLANCAD: 'PLAN_CAD' as MissingDocumentsEnum,
    DOCSYNDIC: 'DOC_SYNDIC' as MissingDocumentsEnum,
    ACTEBASE: 'ACTE_BASE' as MissingDocumentsEnum,
    ANNEXBASE: 'ANNEX_BASE' as MissingDocumentsEnum,
    ETATLIEUX: 'ETAT_LIEUX' as MissingDocumentsEnum,
    GARANTIELOC: 'GARANTIE_LOC' as MissingDocumentsEnum,
    ACTEHEREDITE: 'ACTE_HEREDITE' as MissingDocumentsEnum,
    DEMANDERU: 'DEMANDE_RU' as MissingDocumentsEnum,
    DECLASUCC: 'DECLA_SUCC' as MissingDocumentsEnum,
    PERMISURB: 'PERMIS_URB' as MissingDocumentsEnum,
    PERMISENV: 'PERMIS_ENV' as MissingDocumentsEnum,
    REGBENEF: 'REG_BENEF' as MissingDocumentsEnum,
    MAATREGELEN: 'MAATREGELEN' as MissingDocumentsEnum,
    ARREC: 'AR_REC' as MissingDocumentsEnum,
    LETTREVENTE: 'LETTRE_VENTE' as MissingDocumentsEnum,
    ANB: 'ANB' as MissingDocumentsEnum,
    SCHEMAUNIF: 'SCHEMA_UNIF' as MissingDocumentsEnum,
  };
  export type PendingAutoUploadedDocumentsEnum =
    | 'COMP'
    | 'ACTE'
    | 'TITRE'
    | 'EHYP'
    | 'CAD'
    | 'CAD-REDUIT'
    | 'RU'
    | 'PEB'
    | 'PEB_COMMUN'
    | 'DECOM'
    | 'CI'
    | 'REG'
    | 'ELEC'
    | 'BDES'
    | 'MAIN'
    | 'GARAN'
    | 'VENTE'
    | 'DEPOT'
    | 'BAIL'
    | 'CERTI'
    | 'OVAM'
    | 'CRED'
    | 'ACTE_CRED'
    | 'ACTE_MAND'
    | 'EH_COMPL'
    | 'EH_DEMANDE'
    | 'OTHER'
    | 'IBGE'
    | 'ARTICLE90'
    | 'COMP_SIGNE'
    | 'ACTE_MAIN'
    | 'OFFRE'
    | 'MAP'
    | 'WATERTOETS'
    | 'ASBEST'
    | 'REGISTER'
    | 'ERFGOED'
    | 'CRF'
    | 'RVV'
    | 'BCE'
    | 'PLAN_CAD'
    | 'DOC_SYNDIC'
    | 'ACTE_BASE'
    | 'ANNEX_BASE'
    | 'ETAT_LIEUX'
    | 'GARANTIE_LOC'
    | 'ACTE_HEREDITE'
    | 'DEMANDE_RU'
    | 'DECLA_SUCC'
    | 'PERMIS_URB'
    | 'PERMIS_ENV'
    | 'REG_BENEF'
    | 'MAATREGELEN'
    | 'AR_REC'
    | 'LETTRE_VENTE'
    | 'ANB'
    | 'SCHEMA_UNIF';
  export const PendingAutoUploadedDocumentsEnum = {
    COMP: 'COMP' as PendingAutoUploadedDocumentsEnum,
    ACTE: 'ACTE' as PendingAutoUploadedDocumentsEnum,
    TITRE: 'TITRE' as PendingAutoUploadedDocumentsEnum,
    EHYP: 'EHYP' as PendingAutoUploadedDocumentsEnum,
    CAD: 'CAD' as PendingAutoUploadedDocumentsEnum,
    CADREDUIT: 'CAD-REDUIT' as PendingAutoUploadedDocumentsEnum,
    RU: 'RU' as PendingAutoUploadedDocumentsEnum,
    PEB: 'PEB' as PendingAutoUploadedDocumentsEnum,
    PEBCOMMUN: 'PEB_COMMUN' as PendingAutoUploadedDocumentsEnum,
    DECOM: 'DECOM' as PendingAutoUploadedDocumentsEnum,
    CI: 'CI' as PendingAutoUploadedDocumentsEnum,
    REG: 'REG' as PendingAutoUploadedDocumentsEnum,
    ELEC: 'ELEC' as PendingAutoUploadedDocumentsEnum,
    BDES: 'BDES' as PendingAutoUploadedDocumentsEnum,
    MAIN: 'MAIN' as PendingAutoUploadedDocumentsEnum,
    GARAN: 'GARAN' as PendingAutoUploadedDocumentsEnum,
    VENTE: 'VENTE' as PendingAutoUploadedDocumentsEnum,
    DEPOT: 'DEPOT' as PendingAutoUploadedDocumentsEnum,
    BAIL: 'BAIL' as PendingAutoUploadedDocumentsEnum,
    CERTI: 'CERTI' as PendingAutoUploadedDocumentsEnum,
    OVAM: 'OVAM' as PendingAutoUploadedDocumentsEnum,
    CRED: 'CRED' as PendingAutoUploadedDocumentsEnum,
    ACTECRED: 'ACTE_CRED' as PendingAutoUploadedDocumentsEnum,
    ACTEMAND: 'ACTE_MAND' as PendingAutoUploadedDocumentsEnum,
    EHCOMPL: 'EH_COMPL' as PendingAutoUploadedDocumentsEnum,
    EHDEMANDE: 'EH_DEMANDE' as PendingAutoUploadedDocumentsEnum,
    OTHER: 'OTHER' as PendingAutoUploadedDocumentsEnum,
    IBGE: 'IBGE' as PendingAutoUploadedDocumentsEnum,
    ARTICLE90: 'ARTICLE90' as PendingAutoUploadedDocumentsEnum,
    COMPSIGNE: 'COMP_SIGNE' as PendingAutoUploadedDocumentsEnum,
    ACTEMAIN: 'ACTE_MAIN' as PendingAutoUploadedDocumentsEnum,
    OFFRE: 'OFFRE' as PendingAutoUploadedDocumentsEnum,
    MAP: 'MAP' as PendingAutoUploadedDocumentsEnum,
    WATERTOETS: 'WATERTOETS' as PendingAutoUploadedDocumentsEnum,
    ASBEST: 'ASBEST' as PendingAutoUploadedDocumentsEnum,
    REGISTER: 'REGISTER' as PendingAutoUploadedDocumentsEnum,
    ERFGOED: 'ERFGOED' as PendingAutoUploadedDocumentsEnum,
    CRF: 'CRF' as PendingAutoUploadedDocumentsEnum,
    RVV: 'RVV' as PendingAutoUploadedDocumentsEnum,
    BCE: 'BCE' as PendingAutoUploadedDocumentsEnum,
    PLANCAD: 'PLAN_CAD' as PendingAutoUploadedDocumentsEnum,
    DOCSYNDIC: 'DOC_SYNDIC' as PendingAutoUploadedDocumentsEnum,
    ACTEBASE: 'ACTE_BASE' as PendingAutoUploadedDocumentsEnum,
    ANNEXBASE: 'ANNEX_BASE' as PendingAutoUploadedDocumentsEnum,
    ETATLIEUX: 'ETAT_LIEUX' as PendingAutoUploadedDocumentsEnum,
    GARANTIELOC: 'GARANTIE_LOC' as PendingAutoUploadedDocumentsEnum,
    ACTEHEREDITE: 'ACTE_HEREDITE' as PendingAutoUploadedDocumentsEnum,
    DEMANDERU: 'DEMANDE_RU' as PendingAutoUploadedDocumentsEnum,
    DECLASUCC: 'DECLA_SUCC' as PendingAutoUploadedDocumentsEnum,
    PERMISURB: 'PERMIS_URB' as PendingAutoUploadedDocumentsEnum,
    PERMISENV: 'PERMIS_ENV' as PendingAutoUploadedDocumentsEnum,
    REGBENEF: 'REG_BENEF' as PendingAutoUploadedDocumentsEnum,
    MAATREGELEN: 'MAATREGELEN' as PendingAutoUploadedDocumentsEnum,
    ARREC: 'AR_REC' as PendingAutoUploadedDocumentsEnum,
    LETTREVENTE: 'LETTRE_VENTE' as PendingAutoUploadedDocumentsEnum,
    ANB: 'ANB' as PendingAutoUploadedDocumentsEnum,
    SCHEMAUNIF: 'SCHEMA_UNIF' as PendingAutoUploadedDocumentsEnum,
  };
  export type DocumentTypesEnum =
    | 'COMP'
    | 'ACTE'
    | 'TITRE'
    | 'EHYP'
    | 'CAD'
    | 'CAD-REDUIT'
    | 'RU'
    | 'PEB'
    | 'PEB_COMMUN'
    | 'DECOM'
    | 'CI'
    | 'REG'
    | 'ELEC'
    | 'BDES'
    | 'MAIN'
    | 'GARAN'
    | 'VENTE'
    | 'DEPOT'
    | 'BAIL'
    | 'CERTI'
    | 'OVAM'
    | 'CRED'
    | 'ACTE_CRED'
    | 'ACTE_MAND'
    | 'EH_COMPL'
    | 'EH_DEMANDE'
    | 'OTHER'
    | 'IBGE'
    | 'ARTICLE90'
    | 'COMP_SIGNE'
    | 'ACTE_MAIN'
    | 'OFFRE'
    | 'MAP'
    | 'WATERTOETS'
    | 'ASBEST'
    | 'REGISTER'
    | 'ERFGOED'
    | 'CRF'
    | 'RVV'
    | 'BCE'
    | 'PLAN_CAD'
    | 'DOC_SYNDIC'
    | 'ACTE_BASE'
    | 'ANNEX_BASE'
    | 'ETAT_LIEUX'
    | 'GARANTIE_LOC'
    | 'ACTE_HEREDITE'
    | 'DEMANDE_RU'
    | 'DECLA_SUCC'
    | 'PERMIS_URB'
    | 'PERMIS_ENV'
    | 'REG_BENEF'
    | 'MAATREGELEN'
    | 'AR_REC'
    | 'LETTRE_VENTE'
    | 'ANB'
    | 'SCHEMA_UNIF';
  export const DocumentTypesEnum = {
    COMP: 'COMP' as DocumentTypesEnum,
    ACTE: 'ACTE' as DocumentTypesEnum,
    TITRE: 'TITRE' as DocumentTypesEnum,
    EHYP: 'EHYP' as DocumentTypesEnum,
    CAD: 'CAD' as DocumentTypesEnum,
    CADREDUIT: 'CAD-REDUIT' as DocumentTypesEnum,
    RU: 'RU' as DocumentTypesEnum,
    PEB: 'PEB' as DocumentTypesEnum,
    PEBCOMMUN: 'PEB_COMMUN' as DocumentTypesEnum,
    DECOM: 'DECOM' as DocumentTypesEnum,
    CI: 'CI' as DocumentTypesEnum,
    REG: 'REG' as DocumentTypesEnum,
    ELEC: 'ELEC' as DocumentTypesEnum,
    BDES: 'BDES' as DocumentTypesEnum,
    MAIN: 'MAIN' as DocumentTypesEnum,
    GARAN: 'GARAN' as DocumentTypesEnum,
    VENTE: 'VENTE' as DocumentTypesEnum,
    DEPOT: 'DEPOT' as DocumentTypesEnum,
    BAIL: 'BAIL' as DocumentTypesEnum,
    CERTI: 'CERTI' as DocumentTypesEnum,
    OVAM: 'OVAM' as DocumentTypesEnum,
    CRED: 'CRED' as DocumentTypesEnum,
    ACTECRED: 'ACTE_CRED' as DocumentTypesEnum,
    ACTEMAND: 'ACTE_MAND' as DocumentTypesEnum,
    EHCOMPL: 'EH_COMPL' as DocumentTypesEnum,
    EHDEMANDE: 'EH_DEMANDE' as DocumentTypesEnum,
    OTHER: 'OTHER' as DocumentTypesEnum,
    IBGE: 'IBGE' as DocumentTypesEnum,
    ARTICLE90: 'ARTICLE90' as DocumentTypesEnum,
    COMPSIGNE: 'COMP_SIGNE' as DocumentTypesEnum,
    ACTEMAIN: 'ACTE_MAIN' as DocumentTypesEnum,
    OFFRE: 'OFFRE' as DocumentTypesEnum,
    MAP: 'MAP' as DocumentTypesEnum,
    WATERTOETS: 'WATERTOETS' as DocumentTypesEnum,
    ASBEST: 'ASBEST' as DocumentTypesEnum,
    REGISTER: 'REGISTER' as DocumentTypesEnum,
    ERFGOED: 'ERFGOED' as DocumentTypesEnum,
    CRF: 'CRF' as DocumentTypesEnum,
    RVV: 'RVV' as DocumentTypesEnum,
    BCE: 'BCE' as DocumentTypesEnum,
    PLANCAD: 'PLAN_CAD' as DocumentTypesEnum,
    DOCSYNDIC: 'DOC_SYNDIC' as DocumentTypesEnum,
    ACTEBASE: 'ACTE_BASE' as DocumentTypesEnum,
    ANNEXBASE: 'ANNEX_BASE' as DocumentTypesEnum,
    ETATLIEUX: 'ETAT_LIEUX' as DocumentTypesEnum,
    GARANTIELOC: 'GARANTIE_LOC' as DocumentTypesEnum,
    ACTEHEREDITE: 'ACTE_HEREDITE' as DocumentTypesEnum,
    DEMANDERU: 'DEMANDE_RU' as DocumentTypesEnum,
    DECLASUCC: 'DECLA_SUCC' as DocumentTypesEnum,
    PERMISURB: 'PERMIS_URB' as DocumentTypesEnum,
    PERMISENV: 'PERMIS_ENV' as DocumentTypesEnum,
    REGBENEF: 'REG_BENEF' as DocumentTypesEnum,
    MAATREGELEN: 'MAATREGELEN' as DocumentTypesEnum,
    ARREC: 'AR_REC' as DocumentTypesEnum,
    LETTREVENTE: 'LETTRE_VENTE' as DocumentTypesEnum,
    ANB: 'ANB' as DocumentTypesEnum,
    SCHEMAUNIF: 'SCHEMA_UNIF' as DocumentTypesEnum,
  };
}
